import { createSlice } from '@reduxjs/toolkit';
import { getQuestionByIdAPI, searchQuestionAPI } from '../../../service/quiz/quiz.question.service';

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  questions: [],
  question: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: 'asc',
        property: 'createdAt',
      },
    ],
  },
};

const slice = createSlice({
  name: 'question',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setQuestions(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.questions = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setQuestion(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.question = response.data;
    },
    setQuestionSearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
// Actions
export const { setQuestionSearch } = slice.actions;
// ----------------------------------------------------------------------

export function getQuestions() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { question } = getState();

    const resp = await searchQuestionAPI({ ...question.search, value: `%${question.search.value}%` });

    if (resp.code === '200') dispatch(slice.actions.setQuestions(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}

export function getQuestion(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const resp = await getQuestionByIdAPI(id);
    if (resp.code === '200') dispatch(slice.actions.setQuestion(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}
